__turbopack_context__.v({
  "className": "sharpgrotesk25font_ba8049e6-module__cHQPPa__className",
  "variable": "sharpgrotesk25font_ba8049e6-module__cHQPPa__variable",
});
